<script>
import {mapActions} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import ProposalListItem from "@/components/MainSearch/SearchResult/Proposal/ProposalListItem.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";

export default {
  name: "ProfileProposalsList",
  components: {
    ProposalListItem,
    BaseNoResultMessage,
    InfiniteLoadingLoader
  },
  props: {
    isOwnProfile: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      searchParams: {
        proposerId: this.$route.params.id,
        proposerType: 'USER',
        status: "ACTIVE",
        page: 0,
        size: 10,
      },
      proposalsList: [],
      lastItems: false
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'getProposalsAction'
    ]),
    infiniteHandler($state) {
      if ($state) {
        this.getProposals($state);
      }
    },
    setStatus(status) {
      if (status !== this.searchParams.status) {
        this.searchParams.status = status;
        this.searchParams.page = 0;
        this.proposalsList = [];
        this.lastItems = false;

        if (status === 'CLOSED') {
          this.searchParams.types = 'RIKSDAGEN_PROPOSAL';
        } else  {
          delete this.searchParams.types;
        }

        this.getProposalsAction(this.searchParams).then((resp)=> {
          this.proposalsList = this.proposalsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;
        })
      }
    },
    getProposals($state) {
      if (!this.lastItems) {
        this.getProposalsAction(this.searchParams).then((resp) => {
          this.proposalsList = this.proposalsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;

          if ($state) {
            if (this.proposalsList.length === 0) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      } else {
        $state.complete();
      }
    }
  }
}
</script>

<template>
<div class="profile-proposals-list">
  <div v-if="isOwnProfile" class="profile-content-sub-tabs">
    <div class="profile-content-sub-tab"
         :class="{'profile-content-sub-tab--active': searchParams.status === 'ACTIVE'}"
         @click="setStatus('ACTIVE')"
    >
      {{$t('profile.subTabs.current')}}
    </div>
    <div class="profile-content-sub-tab"
         :class="{'profile-content-sub-tab--active': searchParams.status === 'DRAFT'}"
         @click="setStatus('DRAFT')"
    >
      {{$t('profile.subTabs.drafts')}}
    </div>
    <div class="profile-content-sub-tab"
         :class="{'profile-content-sub-tab--active': searchParams.status === 'CLOSED'}"
         @click="setStatus('CLOSED')"
    >
      {{$t('profile.subTabs.resolved')}}
    </div>
  </div>
  <proposal-list-item v-for="item in proposalsList"
                      :key="item.id"
                      :item-data="item"
  />
  <infinite-loading @infinite="infiniteHandler">
    <template #spinner>
      <InfiniteLoadingLoader v-if="!lastItems"/>
    </template>
    <template #no-more>
      <div></div>
    </template>
    <template #no-results>
      <base-no-result-message :text="$t('profile.noProposals')"/>
    </template>
  </infinite-loading>
</div>
</template>

<style lang="scss" scoped>
.profile-content-sub-tabs {
  display: flex;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, 0.15);
  .profile-content-sub-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 27px;
    background: #f2f2f2;
    font-size: 12px;
    font-weight: 600;
    color: #bbb;
    cursor: pointer;

    &--active {
      color: #7130a0;
      background: #ffffff;
    }
  }
}

.profile-proposals-list {
  padding-top: 10px;
}
</style>